import React, { useEffect, useState } from "react";

import { Breadcrumb, Button, PageHeader, Table, Tag, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { receiptService } from "_services";
import { documentService } from "_services/document.service";

function Documents({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [items, setItems] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    getStockReceipt(id);
    getStockReceipDocuments(id);
  }, []);

  const getStockReceipt = (receiptId) => {
    setLoading(true);
    receiptService
      .getViewById(receiptId)
      .then((x) => {
        setOrder(x.content);
        setLoading(false);
      })
      .catch((errorInfo) => {
        setLoading(false);
        setError(errorInfo);
      });
  };

  const getStockReceipDocuments = (receiptId) => {
    setLoading(true);
    receiptService
      .getDocuments(receiptId)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((errorInfo) => {
        setLoading(false);
        setError(errorInfo);
      });
  };

  const handleDownloadFile = (documentObj) => {
    setDownloading(true);
    documentService
      .downloadDocument(documentObj.id)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${documentObj.documentName}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setDownloading(false);
      })
      .catch((error) => {
        setDownloading(false);
        setError(error);
      });
  };

  const onCancel = () => {
    history.push(`/stock-receipts/${id}/summary`);
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];

    columns.push({
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    });
    columns.push({
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
    });
    columns.push({
      title: "Document Name",
      dataIndex: "documentName",
      key: "documentName",
    });
    columns.push({
      title: "",
      key: "downloadFile",
      render: (text, record) => {
        return (
          <span>
            <Button
              icon={<DownloadOutlined />}
              title="Download Document"
              type="link"
              style={{ marginRight: 10 }}
              loading={downloading}
              onClick={() => handleDownloadFile(record)}
            ></Button>
          </span>
        );
      },
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/stock-receipts">Stock Receipts Search</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`.replace(":id", id)}>
              {order.receiptNumber} ::{" "}
              <Tag
                color={`${
                  order.orderStage === "OPEN"
                    ? "#2db7f5"
                    : order.orderStage === "IN_PROGRESS"
                    ? "#108ee9"
                    : "#87d068"
                }`}
              >
                {order.orderStage}
              </Tag>
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> Documents</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      extra={getActionButtons()}
    >
      <Page inner error={error}>
        <TabMenu menu="documents" id={id} status={order.orderStage} />
        <Spin tip="Loading..." spinning={loading}>
          <Table
            bordered
            pagination={false}
            columns={getLineColumns()}
            dataSource={items}
            size="small"
          />
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default Documents;
